import { ItemType } from '@mimir/common/dto/itemTypes';
import type { NleClipInfo } from './premiereTypes';

export function proxyArtifactSupported(clipInfo: NleClipInfo) {
  return clipInfo.artifactRef?.type == 'TsSegmentRange' || clipInfo.mimirItem?.itemType == ItemType.VIDEO;
}
